import { Card, Col, Row } from 'antd';
import React from 'react';
import EnquiryDashboard from './enquiry-dashboard';
import ProcurementDashboard from './procurement-dashboard';
import ProductionDashboard from './production-dashboard';
import WarehouseDashboard from './warehouse-dashboard';
import ExportDashboard from './new-export';
import PaybleAndDueComponent from './paybale-and-due-dasboard-compnet';
import PackingVendorPay from '../packing-vendor-pay';
import SalesAmountAndNetWeight from './sales-weight-and-amount-comonent';
import SoShippedCount from './so-shipped-component';
import RmCeoDashboard from './rm-ceo-dashboard';
import SalesCeoDashboard from './sales-ceo-dashboard';

const { Meta } = Card;

const CeoDashboard = () => {
  return (
    <div style={{ 
      padding: '16px', 
      backgroundColor: '#f0f2f5', 
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
        <Col xs={24}>
          <Card 
            bordered={false}
            style={{ 
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              height: '100%',
              transition: 'all 0.3s',
              border: '1px solid #1E88E5'
            }}
          >
            <EnquiryDashboard />
          </Card>
        </Col>
        </Row>
        <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
        <Col xs={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              height: '100%',
              transition: 'all 0.3s',
              border: '1px solid #4DB6AC'
            }}
          >
            <ExportDashboard />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              border: '1px solid #FF7043',
              height: '100%',
              transition: 'all 0.3s'
            }}
          >
            <ProcurementDashboard />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              border: '1px solid #81C784'
            }}
          >
            <ProductionDashboard />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              height: '100%',
              border: '1px solid #EF5350'
            }}
          >
            <WarehouseDashboard />
          </Card>
        </Col>

      </Row>
    
      <Row gutter={[24, 24]}>
      <Col xs={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              height: '100%',
              border: '1px solid #EF5350'
            }}
          >
            <RmCeoDashboard />
          </Card>
        </Col>
        <Col xs={24}>
          <Card
            bordered={false}
            style={{
              borderRadius: 12,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              height: '100%',
              border: '1px solid #EF5350'
            }}
          >

            
            <SalesCeoDashboard />
          </Card>
        </Col>

      </Row>
    </div>
  );
};

export default CeoDashboard;